import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input,Row, Col,
    ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import avatar from '../../assets/images/users/3.jpg'
import { auth } from '../../Api'
import { personName } from '../../utils/people'
import { formatPhone } from '../../utils/phone'
import { getName } from 'country-list';
import { baseURL,baseImgURL } from '../../Api/BaseApi';

const TreeTable = treeTableHOC(ReactTable);

class SupervisorInfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked:false,
			open: false,
			modal: false,
			obj: {},
			jsonData: [],
			guardData: [],
			// What the supervisor chose in the app: copies of each client's notifications (view only)
			notificationCopies: [],
			notificationKinds: {},
			supervisorId:"null",
			data: data.makeData(),
			treedata: data.treedata,
			supervisorName:'Supervisor'
		};
	}

	componentDidMount(){
		const {id} = this.props.match.params
        console.log("id:",id)
        var company_id = localStorage.getItem('companyId')
        var req={}
        req.id=id
        req.company_id = company_id
		this.setState({supervisorId:id})
		var that = this
        auth.getSupervisor(req)
            .then((res)=>{
				console.log("res:",res)
			if(res.data.code==200){
			that.setState({
				jsonData: res.data.message.users,
				guardData: res.data.message.guards,
				notificationCopies: res.data.message.notification_copies || [],
				notificationKinds: res.data.message.notification_kinds || {},
				supervisorName: personName(res.data.message.users[0], 'supervisor')
			})
			}
            })
		}



	render() {
		const { data,jsonData,supervisorName,supervisorId,notificationCopies,notificationKinds} = this.state;
        const data2 = this.state.guardData.map((prop, key) => {
			return {
				id: key,
				name: <div onClick={()=>this.props.history.push('/guard-info/'+prop.id)} style={{cursor:"pointer"}}>{personName(prop, 'guard')}</div>,
				CID: prop.CID,
				edit:(
					<div>
						<div onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:",key,obj.name]);
							this.setState({
								modal: !this.state.modal,
								obj: obj,
								
							});
						}}><i className="mdi mdi-lead-pencil"  style={{color:"green"}}/></div>
						<div onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:",key,obj.name]);
							this.setState({
								modal: !this.state.modal,
								obj: obj,
							});
						}}><i className="fas fa-trash-alt" style={{color:"red"}}/></div>
					</div>
					
				)
			};
		});
		
		return <div>
			<Card>
				
				</Card>

                <Row className="space-around">
                    <div className="col-md-6">
                        <Card className="pl-3 pr-3 pb-3">
                            <Row className="toolbar up-card-title">
                                {/* The supervisor's own name */}
                                <div className="b-title"><i className="mr-2 mdi mdi-account-alert mr-10"></i>&nbsp;{jsonData.length!=0?personName(jsonData[0], 'supervisor'):"Supervisor"}</div>
                                <Button color="primary" className="title-edit-button" onClick={()=>{this.props.history.push("/supervisor-edit/"+supervisorId)}}><i className="mdi mdi-lead-pencil"></i> Edit</Button>
                            </Row>
                            {
							jsonData.length!=0?<Row className="toolbar up-card-box">
                                <div><img src = {jsonData[0].avatar != "" ? jsonData[0].avatar == "/storage/avatar.jpg" ? avatar : baseImgURL+jsonData[0].avatar : avatar} className="img-company"></img></div>
                                <div>
									<Row className="company-text-area">
                                        <div className="company-text-key">NAME</div>
                                        <div className="company-text-value">{personName(jsonData[0], 'supervisor')}</div>
                                    </Row>
                                    <Row className="company-text-area">
                                        <div className="company-text-key">CID</div>
                                        <div className="company-text-value">{jsonData[0].CID}</div>
                                    </Row>
                                    <Row className="company-text-area">
                                        <div className="company-text-key">PHONE</div>
                                        <div className="company-text-value">{formatPhone(jsonData[0].phone)}</div>
                                    </Row>
                                    <Row className="company-text-area">
                                        <div className="company-text-key">DISTRICT</div>
                                        <div className="company-text-value">{jsonData[0].district}</div>
                                    </Row>
                                    <Row className="company-text-area">
                                        <div className="company-text-key">COMPANY</div>
                                        <div className="company-text-value">{jsonData[0].company}</div>
                                    </Row>
                                </div>
                            </Row>:<div></div>
                        	}
						</Card>
                    </div>
                    <div className="col-md-6">
                        <Card className="pl-3 pr-3 pb-3">
                            <Row className="toolbar up-card-title">
                                <div className="b-title"><i className="icon-shield mr-10"></i>&nbsp;Guards</div>
                            </Row>
                            <div className="height-10"></div>
                            <ReactTable
                                columns={[
                                    {
                                        Header: "",
                                        id: "row",
                                        maxWidth: 50,
                                        filterable: false,
                                        Cell: (row) => {
                                            return <div>{row.index+1}</div>;
                                        }
                                    },
                                    {
                                        Header: "Name",
                                        accessor: "name"
                                    },
                                    {
                                        Header: "CID",
                                        accessor: "CID"
                                    }
                                ]}
                                defaultPageSize={10}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                data={data2}
                                // filterable
                            />
                        </Card>
                    </div>
                </Row>
                <Row className="space-around">
                    <div className="col-md-12">
                        <Card className="pl-3 pr-3 pb-3">
                            <Row className="toolbar up-card-title">
                                <div className="b-title"><i className="mdi mdi-bell-outline mr-10"></i>&nbsp;Notification copies</div>
                            </Row>
                            <div className="height-10"></div>
                            <p className="text-muted mb-2">
                                Copies of each client's notifications about their guards that this supervisor gets on their phone.
                                The supervisor chooses them in the Mobiliis app; they cannot be changed here.
                            </p>
                            <ReactTable
                                columns={[
                                    {
                                        Header: "Client",
                                        accessor: "name"
                                    },
                                    ...Object.keys(notificationKinds).map((kind) => ({
                                        Header: notificationKinds[kind],
                                        id: kind,
                                        accessor: (row) => (row[kind] ? 'On' : 'Off'),
                                        sortable: false,
                                        filterable: false,
                                        Cell: (cell) => (
                                            <span style={{ color: cell.value === 'On' ? '#1e7b34' : '#888', fontWeight: cell.value === 'On' ? 600 : 400 }}>
                                                {cell.value}
                                            </span>
                                        )
                                    }))
                                ]}
                                defaultPageSize={10}
                                showPaginationBottom={true}
                                noDataText="This supervisor has no clients"
                                className="-striped -highlight"
                                data={notificationCopies}
                            />
                        </Card>
                    </div>
                </Row>
            {/*--------------------------------------------------------------------------------*/}
			{/* End Action table*/}
			{/*--------------------------------------------------------------------------------*/}
            <Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader toggle={this.toggle}>Modal title</ModalHeader>
				<ModalBody>
					<Form onSubmit={this.handleSubmit}>
						<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id} />
						<FormGroup>
							<Label for="name">Name</Label>
							<Input type="text" name="name" id="name" defaultValue={this.state.obj.name} />
						</FormGroup>
						<FormGroup>
							<Label for="designation">Designation</Label>
							<Input type="text" name="designation" id="designation" defaultValue={this.state.obj.designation} />
						</FormGroup>
						<FormGroup>
							<Label for="location">Location</Label>
							<Input type="text" name="location" id="location" defaultValue={this.state.obj.location} />
						</FormGroup>
						<FormGroup>
							<Label for="age">Age</Label>
							<Input type="text" name="age" id="age" defaultValue={this.state.obj.age} />
						</FormGroup>
						<FormGroup>
							<Button color="primary" type="submit">Save</Button>
							<Button color="secondary" className="ml-1" onClick={this.toggle}>Cancel</Button>
						</FormGroup>
					</Form>
				</ModalBody>
			</Modal>
		</div>
	}
    
}

export default SupervisorInfo;
